export default "__VITE_ASSET__elVBKcuN__"